export default __webpack_public_path__ + "static/media/truck-error.55b73454.svg";